export default __webpack_public_path__ + "static/media/bg_308728099.ad65c15d.webp";